import { combineReducers } from 'redux';
import themeReducer from './theme/theme.reducer';
import adminUserReducer from '../features/adminUserSlice';
import publicDataSlice from '../features/publicDataSlice';
import notificationSlice from '../features/notificationSlice';
import trafficStatusMap from '../features/trafficStatusMapSlice';
import adminConfigReducer from '../features/adminConfigSlice';

const rootReducer = combineReducers({
  theme: themeReducer,
  adminUser: adminUserReducer,
  publicData: publicDataSlice,
  notifications: notificationSlice,
  trafficStatusMap: trafficStatusMap,
  adminConfig: adminConfigReducer
});

export default rootReducer;
